module.exports = __webpack_public_path__ + "img/banner.aadd8612.jpg";